import { render, staticRenderFns } from "./scrollTop.vue?vue&type=template&id=24653a77&scoped=true"
import script from "./scrollTop.vue?vue&type=script&lang=js"
export * from "./scrollTop.vue?vue&type=script&lang=js"
import style0 from "./scrollTop.vue?vue&type=style&index=0&id=24653a77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24653a77",
  null
  
)

export default component.exports